import PushNotificationActionCreator from "@/helpers/push/creators/PushNotificationActionCreator";
import OpenCalendarAction from "@/helpers/push/actions/OpenCalendarAction";
export default class OpenCalendarActionCreator extends PushNotificationActionCreator {
    payload;
    constructor(payload) {
        super();
        this.payload = payload;
    }
    create() {
        return new OpenCalendarAction(this.payload.date);
    }
}
